export default __webpack_public_path__ + "static/media/amazon-connect.532a04fe.svg";